import { fetchDeletedDocuments, fetchDocuments, fetchSharedDocuments } from 'slices/documentsActions';
import { useParams } from 'react-router-dom';
import { useAppDispatch } from '../utilities/hooks';
import { ModeDocumentsPageType } from '../types';

export const useFetchDocumentsPage = (mode: ModeDocumentsPageType) => {
    const dispatch = useAppDispatch();
    const { categoryId: categoryIdString } = useParams<{ categoryId?: string }>();
    const categoryId = categoryIdString ? parseInt(categoryIdString) : null;

    const getFetch = () => {
        switch (mode) {
            case 'shared':
                return fetchSharedDocuments;
            case 'deleted':
                return fetchDeletedDocuments;
            case 'documents':
            default:
                return fetchDocuments;
        }
    };

    const fetch = getFetch();

    const fetchData = () => {
        dispatch(fetch(categoryId));
    };

    return {
        categoryId,
        fetchData,
    };
};
